<template>
  <div>
    <van-sticky>
      <van-tabs
        @click="onClickOnlyOne"
        color="#16bbbf"
        title-active-color="#16bbbf"
      >
        <!-- <van-tab name="全部" title="全部"> </van-tab> -->
        <van-tab
          v-for="item in TitleList"
          :key="item.id"
          :name="item.id"
          :title="item.name"
        >
        </van-tab>
      </van-tabs>
    </van-sticky>
    <div class="information">
      <!-- 全部 -->
      <van-list
        v-model="loading"
        :finished="finished"
        :offset="100"
        finished-text="没有更多了"
        @load="onLoad"
        :immediate-check="false"
      >
        <div class="center borderClass" v-for="item in list" :key="item.index">
          <div @click="gotoUrl('/scenery/detail/' + item.AEId)">
            <div class="Content">
              <div
                style="display: inline-block; width: 33%"
                class="ContentA"
                ref="getHeight"
              >
                <img
                  v-if="item.AImg"
                  style="border-radius: 5px; height: 90px; object-fit: cover"
                  :src="item.AImg"
                  alt=""
                />
                <img
                  v-else
                  style="border-radius: 5px; height: 90px; object-fit: cover"
                  src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/cdb4.png"
                  alt=""
                />
              </div>
              <div style="display: inline-block; width: 63%" class="ContentB">
                <div class="centerTitle van-multi-ellipsis--l2">
                  {{ item.Title }}
                </div>
                <span
                  class="centertime van-multi-ellipsis--l2"
                  style="margin: 5px 0px; font-size: 13px; color: #666666"
                  >{{ item.Digest }}</span
                >
              </div>
              <span
                class="centertime"
                style="float: right; margin-top: -10px; color: black"
                >{{ item.IssTime | timeFilter }}</span
              >
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <!-- 发布活动 -->
    <div
      class="backTop"
      @click="gotoUrl('/scenery/addActivity')"
      v-if="isWorkMan == 1"
    >
      <!--  -->
      <img
        class="top_iamge"
        src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/eae3.png"
        alt=""
      />
    </div>
  </div>
</template>
<script>
import { setOpenId, getOpenId, getIsWorkMan } from "@/utils/auth";
import { WxGetPbActElegantPage, WeGetInfoKindInfoPage } from "@/api/RealInfo";
export default {
  data() {
    return {
      isWorkMan: "",
      tkId: 0, //tab栏
      activeName: "",
      list: [], //资讯列表
      listfrom: {
        page: 1,
        limit: 10,
        AKCate: 1,
      }, //查询传参
      hidden: true, //没有更多数据了
      TitleList: [
        {
          id: 1,
          name: "社区活动",
        },
        {
          id: 2,
          name: "党建活动",
        },
        {
          id: 3,
          name: "邻里活动",
        },
      ],
      loading: false,
      finished: false,
      AImg: "",
    };
  },
  filters: {
    timeFilter(value) {
      if (value != undefined) {
        let gstime = value.replace("T", " ");
        return gstime;
      }
    },
  },
  methods: {
    onClickOnlyOne(name, title) {
      this.finished = false;
      this.list = [];
      this.listfrom.AKCate = name;
      this.listfrom.page = 1;
      this.getList();
    },
    // 发布活动
    //跳转到公共页面
    gotoUrl(path) {
      if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateTo({
          url: "../public/goto?path=" + path,
        });
      } else {
        this.$router.push(path);
      }
    },
    // 获取分页列表
    getList() {
      WxGetPbActElegantPage(this.listfrom)
        .then((res) => {
          this.loading = false;
          console.log(res);
          if (res.data.code == 0) {
            let rows = res.data.data; //请求返回当页的列表
            // 加载状态结束

            if (rows == null || rows.length === 0) {
              // 加载结束
              console.log("结束");
              this.finished = true;
              return;
            }
            // 将新数据与老数据进行合并
            this.list = this.list.concat(rows);
            //如果列表数据条数>=总条数，不再触发滚动加载
            if (this.list.length >= res.data.count) {
              this.finished = true;
            }
            this.list.forEach((i) => {
              if (i.Imgs) {
                i.AImg = i.Imgs.split(",")[0];
              }
            });
          } else {
            this.finished = true;
          }
        })
        .catch(() => {});
    },
    // 下拉刷新
    onLoad() {
      this.loading = true;
      this.listfrom.page = this.listfrom.page + 1;
      this.getList();
    },
  },
  mounted() {
    if (this.$route.query["openid"]) {
      setOpenId(this.$route.query["openid"]);
    }
    this.isWorkMan = getIsWorkMan();
    this.getList();
  },
};
</script>
<style scoped>
.hidden {
  text-align: center;
  font-size: 12px;
  color: #ccc;
  margin: 10px 0px 25px 0px;
}
.information {
  width: 95%;
  margin: auto;
}
.borderClass {
  padding: 0;
  box-shadow: 0px 5px 17px 1px rgb(0 0 0 / 7%);
}
.borderClass .Content {
  padding: 8px;
  margin-top: 10px;
}

.backTop {
  display: flex;
  position: fixed;
  bottom: 125px;
  right: 10px;
  width: 75px;
  height: 75px;
}

.top_image {
  width: 75px;
  height: 75px;
}
</style>
